import { render } from "./lorry_target.vue?vue&type=template&id=4219b430"
import script from "./lorry_target.vue?vue&type=script&lang=js"
export * from "./lorry_target.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__